import { CountryPhoneInputValue } from 'antd-country-phone-input/dist/typings';
import { CountryCode, isPossiblePhoneNumber } from 'libphonenumber-js';

import { t } from '../i18n';

export function handlePossiblePhoneNumberValidation(
  _: unknown,
  phoneNumber: CountryPhoneInputValue
): Promise<boolean> {
  if (phoneNumber && phoneNumber.phone) {
    const completePhoneNumber = phoneNumber.code?.toString() + ' ' + phoneNumber.phone;
    const isPhoneNumberPossible = isPossiblePhoneNumber(completePhoneNumber, {
      defaultCountry: phoneNumber.short as CountryCode,
      defaultCallingCode: phoneNumber.code?.toString(),
    });

    if (!isPhoneNumberPossible || (phoneNumber.code === 55 && phoneNumber.phone.length < 10)) {
      return Promise.reject(new Error(t('Número de telefone inválido') as string));
    }
  }
  return Promise.resolve(true);
}

export function handleRequiredPhoneValidation(
  _: unknown,
  phoneNumber: CountryPhoneInputValue
): Promise<boolean> {
  if (!phoneNumber || !phoneNumber.phone) {
    return Promise.reject(new Error(t('Por favor, preencha o campo Telefone') as string));
  }
  return Promise.resolve(true);
}
